import { render } from "./SaleInfoForOwner.vue?vue&type=template&id=31d2a63d"
import script from "./SaleInfoForOwner.vue?vue&type=script&lang=js"
export * from "./SaleInfoForOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__